<template>
	<div class="request-new-password">
		<NavBar :loginPage="true" />
		<v-main>
			<v-row justify="center">
				<v-col lg="4" md="5" sm="7">
					<v-card class="mx-auto mt-3">
						<v-card-title class="primary--text" v-translate>Request Password Reset</v-card-title>
						<v-card-subtitle
							v-translate
						>Enter your user account's verified email address and we will send you a password reset link.</v-card-subtitle>
						<v-card-text class="px-8 pb-0">
							<v-form ref="form" lazy-validation>
								<v-alert v-model="error" color="red lighten-2" class="text-caption" icon="warning">
									<translate>Error! Try again later</translate>
								</v-alert>
								<v-alert v-model="errorEmail" color="red lighten-2" class="text-caption" icon="warning">
									<translate>Email incorrect</translate>
								</v-alert>
								<v-alert v-model="errorConfirmEmail" color="red lighten-2" class="text-caption" icon="warning">
									<translate>Email not confirmed</translate>
								</v-alert>
								<v-alert v-model="success" color="alert" class="text-caption" type="success">
									<translate>Link sent to your email</translate>
								</v-alert>
								<v-text-field
									required
									validate-on-blur
									v-model="email"
									label="Email"
									prepend-inner-icon="mdi-account-circle"
									:rules="emailRules"
									filled
									placeholder=" "
								/>
							</v-form>
						</v-card-text>
						<v-divider></v-divider>
						<v-card-actions class="pa-3">
							<v-spacer></v-spacer>
							<v-btn depressed color="primary" @click="send()" :loading="loading">
								<translate>Send</translate>
							</v-btn>
						</v-card-actions>
					</v-card>
				</v-col>
			</v-row>
		</v-main>
		<Footer :absolute="true" />
	</div>
</template>

<script>
import NavBar from "@/components/authentication/NavBar.vue";
import Footer from "@/components/authentication/Footer.vue";
import axios from "axios";

export default {
	name: "RequestNewPassword",
	components: {
		NavBar,
		Footer
	},
	data: () => ({
		error: false,
		errorEmail: false,
		errorConfirmEmail: false,
		loading: false,
		email: "",
		success: false
	}),
	computed: {
		emailRules() {
			return [
				v => !!v || this.$gettext("Email is required"),
				v => /.+@.+\..+/.test(v) || this.$gettext("E-mail must be valid")
			];
		}
	},
	methods: {
		validate() {
			return this.$refs.form.validate();
		},
		send() {
			if (this.validate()) {
				this.error = false;
				this.errorEmail = false;
				this.errorConfirmEmail = false;
				this.loading = true;
				const formData = new FormData();
				formData.append("email", this.email);
				axios
					.post("/requestreset", formData)
					.then(response => {
						if (response.data.result === "ok") {
							this.success = true;
						} else if (response.data.result === "error") {
							if (response.data.error === "not confirmed") {
								this.errorConfirmEmail = true;
							} else if (response.data.error === "not found") {
								this.errorEmail = true;
							} else {
								this.error = true;
							}
						}
						this.loading = false;
					})
					.catch(error => {
						console.log(error);
						this.error = true;
						this.loading = false;
					});
			}
		}
	}
};
</script>